import React, { createContext, useContext, useState, useEffect } from 'react';

const QuickActionsContext = createContext();

export function QuickActionsProvider({ children }) {
  const [isQuickActionsOpen, setIsQuickActionsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  // Set default state based on screen size
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      
      // Only set the initial state once when component mounts
      if (!isInitialized) {
        // Desktop: default open, Mobile: default closed
        setIsQuickActionsOpen(!mobile);
        setIsInitialized(true);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, [isInitialized]);

  const toggleQuickActions = () => {
    setIsQuickActionsOpen(!isQuickActionsOpen);
  };

  const closeQuickActions = () => {
    setIsQuickActionsOpen(false);
  };

  return (
    <QuickActionsContext.Provider value={{
      isQuickActionsOpen,
      setIsQuickActionsOpen,
      toggleQuickActions,
      closeQuickActions,
      isMobile
    }}>
      {children}
    </QuickActionsContext.Provider>
  );
}

export function useQuickActions() {
  const context = useContext(QuickActionsContext);
  if (!context) {
    throw new Error('useQuickActions must be used within a QuickActionsProvider');
  }
  return context;
}
